import localeEditableField from "./localeEditableField.component";

const localeEditableFieldModule = angular
  .module("app.components.localeEditableField", [])
  .component("localeEditableField", localeEditableField);

export default localeEditableFieldModule;



// WEBPACK FOOTER //
// ./src/components/localeEditableField/localeEditableField.module.js